<template>
  <div class="bg-white border border-gray-300 rounded-lg shadow-sm p-6 mb-4">
    <h3 class="flex items-center justify-between mb-4">
      <span class="leading-none">{{ $gettext('Propriété') }} {{ index + 1 }}</span>
      <button
        @click.prevent="$emit('remove')"
        class="text-indigo-600 hover:text-indigo-900 transition-transform duration-200 hover:scale-110 flex items-center"
      >
        <MinusCircleIcon class="size-7 align-middle" aria-hidden="true" />
      </button>
    </h3>

    <div class="space-y-4 flex-1">
      <FormPropertyComboboxField
        v-model="normalized.relationships.property.data"
        :field-path="'relationships.property.data'"
        :field-label="$gettext('Propriété')"
        :errors="errors"
      />
      <FormMoneyField
        v-model="normalized.attributes.listingRent"
        :field-path="'attributes.listingRent'"
        :field-label="$gettext('Loyer de commercialisation')"
        :errors="errors"
      />

      <FormTextareaField
        v-model="normalized.attributes.details"
        :field-path="'attributes.details'"
        :field-label="$gettext('Détails du bien')"
        :errors="errors"
      />
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from "vue";
import { MinusCircleIcon } from "@heroicons/vue/24/outline";
import { useGettext } from "vue3-gettext";
import FormPropertyComboboxField from "@/components/form-fields/FormPropertyComboboxField.vue";
import FormMoneyField from "@/components/form-fields/FormMoneyField.vue";
import FormTextareaField from "@/components/form-fields/FormTextareaField.vue";

const { $gettext } = useGettext();

const props = defineProps({
  modelValue: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
  index: { type: Number, required: true }
});
const emit = defineEmits(["update:modelValue", "remove"]);

const normalized = reactive({
  ...props.modelValue,
  attributes: {
    details: props.modelValue.attributes?.details ?? null,
    listingRent: props.modelValue.attributes?.listingRent ?? null
  },
  relationships: {
    property: {
      data: props.modelValue.relationships?.property?.data ?? {}
    }
  }
});

watch(
  normalized,
  (val) => {
    emit("update:modelValue", val);
  },
  { deep: true }
);
</script>
